import moment from "moment";
import axios from "axios";
import url from "./url";
import CryptoJS from 'crypto-js';
import { RestAPI as API } from '@aws-amplify/api-rest';
import { API_SEGURIDAD } from "./consts";
import { withAuditoryDigitalData } from "@auditory/provider/hooks";
import { decodeB64 } from "./Utils";
import { DAY_TO_MILISECONDS } from "@/features/Comprar/vida-devolucion/step-initial/constants/cyber";

const widthScreen = window.screen.width;

export const addDot = (num) => {
  let str = num.toString().split(".");
  if (str[0].length >= 3) {
    //add comma every 3 digits befor decimal
    str[0] = str[0].replace(/(\d)(?=(\d{2})+$)/g, "$1.");
  }

  return str.join(".");
};

const formatNumberToDecimal = (number) => {
  if (number < 10 && number > 0) {
    return "0" + number;
  } else {
    return number;
  }
};

const getSession = () => {
  return JSON.parse(localStorage.getItem("currentUser"));
};
const isApp = () => {
  try {
    let url = extractHostname(window.location.href);
    url = url.pathname.replace(".html", "");
    return url.substring(url.length - 3) === "app";
  } catch (error) {
    return null;
  }
};

const getBody = (data, trace) => ({
  body: {
    request: {
      trace: trace || getTrace(),
      payload: data,
    },
  },
});

const getBodySoat = (data, trace) => ({
  body: {
    payload: {
      request: {
        trace: trace || getTrace(),
        payload: data,
      },
    },
  },
});

const getBodySimple = (data) => ({
  body: {
    payload: data,
  },
});

const getBodyAmplify = (data) => ({
  body: {
    request: {
      trace: getTrace(),
      payload: data,
    },
  },
  // headers: {
  //   'id-client': getIdClient(),
  // }
});

const getBodySimpleWithTrace = (data, trace) => ({
  body: {
    trace: trace || getTrace(),
    payload: data,
  },
});

const getTrace = (serviceId) => ({
  consumerId: "ACRONIMO_O_ID_NOMBRE_CANAL",
  serviceId: serviceId,
  moduleId: "ACRONIMO_O_ID_MODULO_CANAL",
  channelCode: "WEB",
});

const getLeadsTrace = (serviceId) => ({
  serviceId: serviceId,
  consumerId: "WEBPUB",
  channelCode: "WEB",
  traceId: new Date().getTime().toString(),
});

const formattingDate = (date) =>
  new Date(moment(date, "DD/MM/YYYY").format("MM/DD/YYYY HH:mm:ss"));

const downloadFile = (response, type, name, document) => {
  const binary = atob(response.replace(/\s/g, ""));
  const len = binary.length;
  const buffer = new ArrayBuffer(len);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }
  const blob = new Blob([view], { type });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

function downloadPdf(response, type, name, document) {
  if (response.status) {
    const blob = new Blob([response.payload], {
      type: type,
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

const formattingPaymentDate = (date) =>
  moment(new Date(date)).format("DD/MM/YY");

const formattingNumber = (number) => {
  const s = `${number}`;
  if (s.length < 2) {
    return `0${s}`;
  }
  return s;
};

const zerofill = (n) => (n < 10 ? `0${n}` : n);

const urlSearch = (name) => {
  const results = new RegExp(`[\?&]${name}=([^&#]*)`).exec(
    window.location.href
  );

  if (results == null) {
    return null;
  }
  return decodeURI(results[1]) || 0;
};

const getLocalstorage = (key) => JSON.parse(localStorage.getItem(key));

const handlerErrors = (error) => {
  let notification = {};
  switch (error.httpCode) {
    case 500:
      notification = {
        title: "¡Error Interno!",
        messages:
          error.messages && error.messages[0]
            ? error.messages[0]
            : "Ocurrió un error desconocido",
        type: "error",
      };
      break;
    case 400:
      notification = {
        title: "¡Solicitud Incorrecta!",
        messages:
          error.messages && error.messages[0]
            ? error.messages[0]
            : "Ocurrió un error en la petición",
        type: "error",
      };
      break;
    default:
      notification = {
        title: "¡Sucedió algo!",
        messages: "Ha ocurrido un problema. Intente nuevamente",
        type: "error",
      };
      break;
  }
  return notification;
};

const addQueryString = (url, queryString) => {
  if (queryString) {
    let isQuestionMarkPresent = url && url.indexOf("?") !== -1,
      separator = isQuestionMarkPresent ? "&" : "?";
    url += separator + queryString;
  }
  return url;
};

const removeDuplicateByAtributte = (array, attribute) => {
  const unique = array
    .map((e) => e[attribute])
    .map((e, i, final) => final.indexOf(e) === i && i)
    .filter((e) => array[e] && array[e][attribute])
    .map((e) => array[e]);
  return unique;
};

const formattingAlertDate = (date) =>
  moment(new Date(date))
    .locale("es")
    .format("LL");

/*
 source: https://es.stackoverflow.com/questions/48958/redondear-a-dos-decimales-cuando-sea-necesario

 1. Adaptado de MDN (solución recomendada)
 Tomando el código de Redondeo Decimal, adapté la solución para que realice un redondeo aritmético simétrico con números negativos. Es decir que redondee -1.5 ≈ -2.
 * */
const round = (num, decimales = 1) => {
  let signo = num >= 0 ? 1 : -1;
  num = num * signo;
  if (decimales === 0)
    //con 0 decimales
    return signo * Math.round(num);
  // round(x * 10 ^ decimales)
  num = num.toString().split("e");
  num = Math.round(
    +(num[0] + "e" + (num[1] ? +num[1] + decimales : decimales))
  );
  // x * 10 ^ (-decimales)
  num = num.toString().split("e");
  return signo * (num[0] + "e" + (num[1] ? +num[1] - decimales : -decimales));
};

/*
 2. Utilizando Intl.NumberFormat()
 La función Intl.NumberFormat([locales[, options]]) permite redondear un número correctamente con código nativo. Sin embargo,
 como se verá más adelante, esta función acepta opciones sensibles al idioma, haciéndola significativamente más lenta.
 * */
const roundWithComma = (numero, decimales = 2, usarComa = false) => {
  let opciones = {
    maximumFractionDigits: decimales,
    useGrouping: false,
  };
  usarComa = usarComa ? "es" : "en";
  return new Intl.NumberFormat(usarComa, opciones).format(numero);
};

/*
 Link: http://jsfiddle.net/jacobuid/ezbao2a3/
 * */

const addComma = (num) => {
  let str = num.toString().split(".");
  if (str[0].length >= 4) {
    //add comma every 3 digits befor decimal
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
  }
  /* Optional formating for decimal places
  if (str[1] && str[1].length >= 4) {
      //add space every 3 digits after decimal
      str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }*/
  return str.join(".");
};

/*
 Stackoverflow: Add commas or spaces to group every three digits
 Link: https://stackoverflow.com/a/41719125
 * */
const addCommasAndPoint = (num = 0) => {
  let tempNumber = num.toFixed(2).split(".");
  let tempNumberLeft = tempNumber[0] || "0";
  let tempNumberRight = tempNumber[1] || "0";
  let temp = addComma(num);
  // 1234567.890123 will equal to 1,234,567.890 123

  let divideNumber = (temp + "").split(".");
  let numberLeft = divideNumber[0] || "0";
  let numberRight = divideNumber[1] || "0";

  if (parseFloat(tempNumberLeft) === 0) {
    numberLeft = "0";
  }

  if (parseFloat(tempNumberRight) === 0) {
    numberRight = "00";
  } else {
    let tempNumberWithZeros = parseFloat("0." + numberRight)
      .toFixed(2)
      .split(".");
    numberRight = tempNumberWithZeros[1];
  }

  return `${numberLeft}.${numberRight}`;
};

/*
 * Link: https://www.jacklmoore.com/notes/rounding-in-javascript/
 * */

const extractHostname = (url) => {
  const match = url.match(
    /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
  );
  return (
    match && {
      href: url,
      protocol: match[1],
      host: match[2],
      hostname: match[3],
      port: match[4],
      pathname: match[5],
      search: match[6],
      hash: match[7],
    }
  );
};
const roundTo = (value, decimals = 2) => {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
};

const eventFire = (el, etype) => {
  if (el.fireEvent) {
    el.fireEvent("on" + etype);
  } else {
    let evObj = document.createEvent("Events");
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
};

const mouseClickEvents = ["mousedown", "click", "mouseup"];
const simulateMouseClick = (element) => {
  mouseClickEvents.forEach((mouseEventType) =>
    element.dispatchEvent(
      new MouseEvent(mouseEventType, {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1,
      })
    )
  );
};

// convert the input array to camel case
const toCamelCase = (str) => {
  return str
    .replace(/\s(.)/g, function ($1) {
      return $1.toUpperCase();
    })
    .replace(/\s/g, "")
    .replace(/^(.)/, function ($1) {
      return $1.toLowerCase();
    });
};

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const ellipsis = function (str, size) {
  let defaultValue = str;
  if (typeObject(str) === "String" && str.length > size) {
    let names = str.toString().split(" ");
    if (Array.isArray(names)) {
      defaultValue = names[0];
      if (defaultValue.length > size) {
        defaultValue = defaultValue.substring(0, size - 1).concat("...");
      }
    }
  }
  return defaultValue;
};

const completeLink = function (str) {
  let defaultValue = str;
  let htmlExtension = ".html";
  if (typeObject(str) === "String" && !str.includes(htmlExtension)) {
    defaultValue = defaultValue.concat(htmlExtension);
  }
  return defaultValue;
};

const typeObject = (value) => {
  let stringConstructor = "test".constructor;
  let arrayConstructor = [].constructor;
  let objectConstructor = {}.constructor;

  function whatIsIt(object) {
    if (object === null) {
      return "null";
    }
    if (object === undefined) {
      return "undefined";
    }
    if (object.constructor === stringConstructor) {
      return "String";
    }
    if (object.constructor === arrayConstructor) {
      return "Array";
    }
    if (object.constructor === objectConstructor) {
      return "Object";
    }
    {
      return "don't know";
    }
  }

  return whatIsIt(value);
};

const getAsJson = (value) => {
  if (typeObject(value) === "Object") {
    return value;
  } else if (typeObject(value) === "String") {
    if (value.charAt(0) === "[" && value.charAt(value.length - 1) === "]") {
      return JSON.parse(value);
    } else if (
      value.charAt(0) === "{" &&
      value.charAt(value.length - 1) === "}"
    ) {
      return JSON.parse(value);
    } else {
      return {};
    }
  } else if (typeObject(value) === "Array") {
    return value;
  } else {
    return {};
  }
};

const capitalizeString = (names) => {
  let namesCapitalize = "";

  if (!names) {
    return "";
  }

  if (Array.isArray(names)) {
    namesCapitalize = names.map(
      (name) => name.charAt(0) + name.slice(1).toLowerCase()
    );
    return namesCapitalize.join(" ");
  }

  return (namesCapitalize = names.charAt(0) + names.slice(1).toLowerCase());
};

const capitalizeFullName = (fullName) =>
  fullName
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const getTemplateHtmlFromAEM = function (pathAEM) {
  if (pathAEM) {
    return new Promise((resolve, reject) => {
      axios
        .get(pathAEM)
        .then((template) => {
          resolve(template.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const wordsUpperCase = function (str) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
};

const sendEmailNotification = (
  props,
  dataReplaceToSubject,
  dataReplaceToEmail,
  recipient,
  attachment = null,
  callback
) => {
  const currentUrl = window.location.href.split("/");

  return new Promise((resolve, reject) => {
    const { subjectEmail, templateemail } = props;

    let request = {};
    request.adjunto = attachment ? attachment : null;
    request.de = "RIMAC Digital <rimacdigital@rimac.com.pe>";

    getTemplateHtmlFromAEM(templateemail)
      .then((html) => {
        request.para = dataReplaceToEmail.EMAIL;

        request.asunto = `Cotización: Seguro Vida ahorro con devolución - Plan ${dataReplaceToEmail.PLAN_SELECTED}`;

        Object.keys(dataReplaceToEmail).forEach((key) => {
          html = html.replace(
            new RegExp(`%%${key}%%`, "g"),
            dataReplaceToEmail[key]
          );
          html = html.replace(
            new RegExp(`000${key}000`, "g"),
            dataReplaceToEmail[key]
          );
        });

        request.template = html;
        return request;
      })
      .then((request) => {
        enviarCorreo(request, callback).then((response) => {
          if (response && response.response.status.success && callback) {
            callback();
          }
        });
      });
  });
};

const getBodyAPI = (data, serviceId) => ({
  request: {
    trace: {
      serviceId: serviceId,
      consumerId: "WEBPUB",
      channelCode: "WEB",
      traceId: new Date().getTime().toString(),
    },
    payload: data,
  },
});

function enviarCorreo(payload) {
  const request = {
    headers: {
      "Content-Type": "application/json",
    },
    body: getBodyAPI(payload, API_SEGURIDAD),
  };
  return Promise.resolve(API.post("UTILITARIOS", url.enviarCorreo, request));
}

const trackResetPasswordCompleted = () => {
  window.digitalData.push({
    event: "trackResetPasswordCompleted",
  });
};

const trackInsuranceWithRefundQuote = () => {
  window.digitalData.push({
    event: "trackLifeWithYouInsuranceWithRefundQuote",
  });
};

export const sendMessageToApp = (message) => {
  try {
    if (
      window.ReactNativeWebView &&
      typeof window.ReactNativeWebView.postMessage === "function"
    ) {
      window.ReactNativeWebView.postMessage(message);
    } else {
      if (window.webkit) {
        window.webkit.messageHandlers.MessageHandler.postMessage(message);
      } else {
        console.log(message);
      }
    }
  } catch (error) {
    console.error("Error sending message to app:", error);
  }
};

const calcularEdad = (fecha) => {
  var hoy = new Date();
  var cumpleanos = new Date(fecha);
  var edad = hoy.getFullYear() - cumpleanos.getFullYear();
  var m = hoy.getMonth() - cumpleanos.getMonth();

  if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
    edad--;
  }

  return edad;
};

const isAgeAllowed = (olderAge, youngerAge, age) =>
  age <= olderAge && age >= youngerAge;

const changeFinalizadoValueOnLead = (leadData, value) => {
  const newLeadData = { ...leadData };
  return { ...newLeadData, ...value };
};

//Tagging Scripts
const getTagApplication = (product, leadid, event) => {
  return window.digitalData.push({
    application: {
      product,
    },
    contact: {
      leadid,
    },
    event,
  });
};
const getTagMetadata = (key, value, event) => {
  return window.digitalData.push({
    metadata: {
      key,
      value,
    },
    event,
  });
};
const getTagEvent = (event) => {
  return window.digitalData.push({ event });
};

const getTagError = (code, message, event, apiUrl = "") => {
  withAuditoryDigitalData({
    code,
    error: message,
    endpoint: apiUrl,
    urlPageError: "004",
  });
  return window.digitalData.push({
    error: {
      code,
      message,
    },
    event,
  });
};

export const sendTagChain = (tagList, delay = 100) => {
  const runNext = (index) => {
    if (index >= tagList.length) return;

    const item = tagList[index];

    setTimeout(() => {
      switch (item.type) {
        case "getTagAction":
          getTagAction(
            item.group,
            item.category,
            item.name,
            item.label,
            item.event
          );
          break;
        case "getTagVirtual":
          getTagVirtual(item.name);
          break;
        case "setEmailSha":
          setEmailSha(item);
          break;
        case "setPhoneSha":
          setPhoneSha(item);
          break;
        case "getTagLog":
          getTagLog(item.message);
          break;
        case "getTagError":
          getTagError(item.code, item.message, "trackError", item?.apiUrl);
          break;
        case "getTagMetadata":
        default:
          getTagMetadata(item.key, item.value, "trackMetadata");
          break;
      }

      runNext(index + 1);
    }, delay);
  };

  runNext(0);
};

const getTagUnexpectedError = (error, apiUrl) => {
  // manejo de errores api que no siguen el contrato comun de los errores

  const responseInfo = {
    responseData: error?.response?.data,
    status: error?.response?.status,
    headers: error?.response?.headers,
    errStack: error?.stack,
    errMessage: error?.message,
  };

  const requestInfo = {
    requestData: error?.config?.data,
    status: error?.config?.status,
    headers: error?.config?.headers,
    method: error?.config?.method,
    url: error?.config?.url,
  };

  withAuditoryDigitalData({
    code: responseInfo?.status,
    error: responseInfo,
    endpoint: apiUrl,
    urlPageError: "004",
    request: requestInfo,
  });

  return window.digitalData.push({
    error: {
      code: error?.response?.status || "500",
      message: error?.message || "Error interno del servicio",
    },
    event: "trackError",
  });
};

const getTagLog = (message, event = "trackLog") => {
  withAuditoryDigitalData({
    code: "TRACK_LOG",
    error: message,
    endpoint: "",
    urlPageError: "004",
  });

  return window.digitalData.push({
    log: {
      message,
    },
    event,
  });
};

const getTagVirtual = (name) => {
  return window.digitalData.push({
    virtual: {
      name,
    },
    event: "trackVirtual",
  });
};

const getTagChannel = (channel, name, event) => {
  return window.digitalData.push({
    form: {
      channel,
      name,
    },
    event,
  });
};

const getTagAction = (group, category, name, label, event) => {
  return window.digitalData.push({
    action: {
      group,
      category,
      name,
      label,
    },
    event,
  });
};

const getTagAction2 = (group, category, event1, label, event2) => {
  return window.digitalData.push({
    action: {
      group,
      category,
      label,
      event: event1,
    },
    event: event2,
  });
};

const getTagPayment = (tagPaymentData) => {
  const {
    idQuote,
    productAmount,
    productCode,
    variant,
    productName = "Seguro Vida Devolución Garantizada",
    metadata = null,
    currency = "",
    country = ""
  } = tagPaymentData;

  let tagProducts = {
    code: productCode,
    name: productName,
    variant,
    brand: "Rimac Seguros",
    price: productAmount,
    quantity: "1",
  };

  if (country) tagProducts.country = country;

  const content = {
    transaction: {
      id: idQuote,
      store: "Rimac Seguros Online",
      revenue: {
        amount: productAmount,
        currency,
      },
      payment: {
        term: "",
        type: "Tarjeta",
      },
      coupon: "",
      products: [
        tagProducts
      ],
    },
    event: "trackPurchase",
  };

  if (!!metadata) {
    content.transaction = { ...content.transaction, metadata };
  }

  window.digitalData.push(content);
};

//Metodos para obtener parametros de campaña
const getParameterValue = (sParametroNombre, utm) => {
  const sPaginaURL = utm || window.location.search.substring(1) || "";
  const sURLVariables = sPaginaURL.split("&");
  for (let i = 0; i < sURLVariables.length; i++) {
    const sParametro = sURLVariables[i].split("=");
    if (sParametro[0] === sParametroNombre) {
      return sParametro[1];
    }
  }
  return null;
};

const convertParametersToArray = (parameter) => {
  const param = getParameterValue(parameter);
  return param.indexOf(":") != -1 ? param.split(":") : param.split("%3A");
};

const getCampaign = (deleteCanal = true) => {
  var source = "",
    origenCampania = "",
    origenContenido = "",
    origenMedio = "",
    origenTipoPlan = "";
  if (getParameterValue("gclid") != null) {
    source = "Google Adwords";
    if (getParameterValue("origen_fuente") != null) {
      source = getParameterValue("origen_fuente");
    }
    if (getParameterValue("origen_medio") != null) {
      origenMedio = getParameterValue("origen_medio");
    }
    if (getParameterValue("origen_campaign") != null) {
      origenCampania = getParameterValue("origen_campaign");
    }
  } else if (getParameterValue("utm_source") != null) {
    source = getParameterValue("utm_source");
    origenCampania = getParameterValue("utm_campaign");
    origenContenido = getParameterValue("utm_content");
  } else if (getParameterValue("origen_fuente") != null) {
    source = getParameterValue("origen_fuente");
  }

  if (getParameterValue("utm_medium") != null) {
    origenMedio = getParameterValue("utm_medium");
  } else if (getParameterValue("origen_medio") != null) {
    origenMedio = getParameterValue("origen_medio");
  }

  if (null != getParameterValue("tipoplan")) {
    origenTipoPlan = getParameterValue("tipoplan");
  }
  //Regla mcid
  if (getParameterValue("mcid") != null) {
    let arrParameters = convertParametersToArray("mcid");
    source = arrParameters[0];
    origenMedio = arrParameters[1];
    origenCampania = arrParameters[2];
    origenContenido = arrParameters.slice(3).join(":");
  }
  //Regla pcid
  if (getParameterValue("pcid") != null) {
    let arrParameters = convertParametersToArray("pcid");
    source = "Internal Campaigns";
    origenMedio = arrParameters.slice(0, 2).join(":");
    origenCampania = arrParameters[2];
    origenContenido = arrParameters.slice(3).join(":");
  }
  //Regla rfid
  if (getParameterValue("rfid") != null) {
    let arrParameters = convertParametersToArray("rfid");
    source = "Internal Reference";
    origenMedio = arrParameters.slice(0, 2).join(":");
    origenCampania = arrParameters[2];
    origenContenido = arrParameters.slice(3).join(":");
  }

  if (deleteCanal) {
    sessionStorage.removeItem("canal");
    if (null != getParameterValue("canal")) {
      const canal = decodeB64(getParameterValue("canal"));
      sessionStorage.setItem("canal", canal);
    }
  }

  return {
    source,
    origenCampania,
    origenContenido,
    origenMedio,
    origenTipoPlan,
  };
};

const setActionTag = ({
  group,
  category,
  action,
  label,
  event = "trackAction",
}) => {
  window.digitalData.push({
    action: {
      group: group,
      category: category,
      name: action,
      label: label,
    },
    event: event,
  });
};

const setTagDigitalID = (id) => {
  return window.digitalData.push({
    audience: {
      id,
      authState: "Authenticated",
    },
    event: "trackAudience",
  });
};

const setTrackingErrorPago = (quoteId, orderNumber, externalCode) => {
  window.digitalData.push({
    metadata: {
      key: "IDTransaccion",
      value: `${quoteId} | ${orderNumber} | ${externalCode}`,
    },
    event: "trackMetadata",
  });
};

export const sendEmailPurchase = (props) => {
  const { templateEmail, replaceToEmail } = props;
  let html = templateEmail;
  if (html.includes("%%")) {
    Object.keys(replaceToEmail).forEach((key) => {
      html = html.replace(new RegExp(`%%${key}%%`, "g"), replaceToEmail[key]);
      // console.log('html:', html);
    });
  }
  return html;
};

const sendEmailSuccessfulPurchase = async (props) => {
  const { templateEmail, replaceToEmail } = props;
  let html = await fetch(templateEmail);
  const templateText = await html.text();
  html = templateText;

  Object.keys(replaceToEmail).forEach((key) => {
    html = html.replace(new RegExp(`%%${key}%%`, "g"), replaceToEmail[key]);
  });

  if (html.includes("%%")) {
    Object.keys(replaceToEmail).forEach((key) => {
      html = html.replace(new RegExp(`%%${key}%%`, "g"), replaceToEmail[key]);
    });
  }

  const response = {
    template: html,
    para: [replaceToEmail.email],
    de: "RIMAC Digital <rimacdigital@rimac.com.pe>",
    asunto: "Compra exitosa",
  };

  return response;
};

const isAppleDevice = (_) => /iP(hone|od|ad)/.test(window.navigator.userAgent);
const getDeviceOS = (_) => {
  let valueUserAgent = window.navigator.userAgent;
  if (/iP(hone|od|ad)/.test(valueUserAgent)) {
    return "ios";
  }
  if (/Android/.test(valueUserAgent)) {
    return "android";
  }
  return "unknown";
};

const sendTagError = (error, apiUrl) => {
  const errorResponse = error?.response;
  const errorData = errorResponse?.data;
  const errorApi = errorData?.response?.status?.error;
  if (errorApi) {
    if (Array.isArray(errorApi?.messages)) {
      errorApi?.messages.map((item) =>
        getTagError(errorApi.httpCode, item, "trackError", apiUrl)
      );
    } else {
      getTagError(errorApi.httpCode, errorApi.messages, "trackError");
    }
    getTagMetadata("Endpoint", apiUrl, "trackMetadata");
  } else {
    getTagUnexpectedError(error, apiUrl);
    getTagMetadata("Endpoint", apiUrl, "trackMetadata");
  }
};

const getDocumentTypeName = (documentType) => {
  switch (Number(documentType)) {
    case 2:
      return "DNI";
    case 4:
      return "CE";
    case 1:
      return "RUC";
    default:
      return "DNI";
  }
};

const validateVidaPlus = () => window.location.pathname.includes("vida-plus");

const validateViajes = () => window.location.pathname.includes("seguro-viajes");

const validateVidaEndosable = () =>
  window.location.pathname.includes("vida-endoso-con-devolucion");

const getTipoViaValue = (idTipoVia) => {
  let value = "";
  switch (idTipoVia) {
    case "AV": {
      value = "Avenida";
      break;
    }
    case "CL": {
      value = "Calle";
      break;
    }
    case "JR": {
      value = "Jirón";
      break;
    }
    default: {
      value = "";
      break;
    }
  }
  return value;
};

const getClientUbigeo = (payload) => {
  const { direccion } = payload;
  const ubigeo = direccion?.ubigeo;
  if (direccion && ubigeo) {
    const ideDepartamento = `0${ubigeo.substring(0, 2)}`;
    const ideProvincia = `0${ubigeo.substring(2, 4)}`;
    const ideDistrito = `0${ubigeo.substring(4, 6)}`;

    const descripcionDepartamento = direccion.dscdpto;
    const descripcionProvincia = direccion.dscprov;
    const descripcionDistrito = direccion.dscdist;

    const departamento = {
      value: ideDepartamento,
      text: descripcionDepartamento,
      ideDepartamento,
      descripcionDepartamento,
    };
    const provincia = {
      value: ideProvincia,
      text: descripcionProvincia,
      ideProvincia,
      descripcionProvincia,
    };
    const distrito = {
      value: ideDistrito,
      text: descripcionDistrito,
      ideDistrito,
      descripcionDistrito,
      ubigeo,
    };
    const nombreVia = direccion.nomvia || "";
    const tipoVia = {
      id: direccion?.idptipovia,
      text: getTipoViaValue(direccion.idptipovia),
      value: direccion?.idptipovia,
    };
    const numeroVia = direccion.nrovia || "";
    return {
      departamento,
      provincia,
      distrito,
      nombreVia,
      tipoVia,
      numeroVia,
    };
  }
  return {
    departament: "",
    provincia: "",
    distrito: "",
    nombreVia: "",
    tipoVia: "",
    numeroVia: "",
  };
};

const getTrackBDU = (key, origen, { typeDoc, numDoc }, porcentaje) => {
  if (porcentaje) {
    return getTagMetadata(
      key,
      `${origen || "NE"}_${getDocumentTypeName(
        typeDoc
      )}-${numDoc}_${porcentaje}%`,
      "trackMetadata"
    );
  }
  return getTagMetadata(
    key,
    `${origen || "NE"}_${getDocumentTypeName(typeDoc)}-${numDoc}`,
    "trackMetadata"
  );
};

const validateBirthday = (day, month, year) => {
  const today = new Date();
  let dayVar = false;
  let monthVar = false;
  let yearVar = false;
  let isValidDay = true;
  if (day.length) {
    dayVar = Number(day) < 32 && Number(day) !== 0;

    if (month.length) {
      let validDay = new Date(Number(year), Number(month), 0).getDate();
      isValidDay = Number(day) <= validDay;
    }
  }
  if (month.length) {
    monthVar = Number(month) <= 12 && Number(month) !== 0;
  }
  if (year.length) {
    yearVar = new RegExp(/^(19|20)\d{2}$/).test(year);
  }
  if (
    day.length &&
    month.length &&
    year.length &&
    Number(today.getFullYear()) <= Number(year)
  ) {
    if (
      !moment(`${year}-${month}-${day}`).isBefore(
        `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
      )
    ) {
      return {
        showError: true,
      };
    }
  }
  return {
    showError:
      (!dayVar && day.length) ||
      (!monthVar && month.length) ||
      (!yearVar && year.length) ||
      !isValidDay,
    day: (!dayVar && day.length) || !isValidDay,
    month: !monthVar && month.length,
    year: !yearVar && year.length,
  };
};

const getTotalPassengers = (data) => {
  const adults = data?.adulto;
  const childs = data?.child;
  let totalPassengers = [];

  if (Array.isArray(adults)) {
    totalPassengers = [...totalPassengers, ...adults];
  }
  if (Array.isArray(childs)) {
    totalPassengers = [...totalPassengers, ...childs];
  }
  return totalPassengers;
};

const getMarkingPassengersValue = (data, withComa = false) => {
  const adults = data?.adulto || [];
  const childs = data?.child || [];
  const adultText = `${adults.length} ${adults.length === 1 ? "adulto" : "adultos"
    }`;
  const childText = `${withComa ? "," : " -"} ${childs.length} ${childs.length === 1 ? "niño" : "niños"
    }`;
  let passengersText = adultText;
  if (childs.length > 0) {
    passengersText = adultText + childText;
  }
  return passengersText;
};

const getMarkingPassengersData = (data) => {
  const adults = data?.adulto;
  const childs = data?.child;
  const adultText = `Adultos - ${adults.length}`;
  const childText = `|Niños -  ${childs.length}`;
  let passengersText = adultText;
  if (childs.length > 0) {
    passengersText = adultText + childText;
  }
  return passengersText;
};

export const maskString = (
  str,
  hiddenCount = 3,
  maskChar = "*"
) => {
  if (!str || str.length <= hiddenCount) {
    return str.charAt(0) + maskChar.repeat(str.length - 1);
  }

  const visible = str.slice(0, str.length - hiddenCount);
  const masked = maskChar.repeat(hiddenCount);
  return `${visible}${masked}`;
};

const maskEmail = (email) => {
  const [user, domain] = email.split("@");
  if (!user || !domain) return email;

  const maskedUser = maskString(user);

  return `${maskedUser}@${domain}`;
};

const convertToSafeString = (str) => (str ?? "").trim();

const getHash256FromString = (str) =>
  CryptoJS.SHA256(str).toString();

const setMetadataSha = ({ product, event, sha: _sha }) => {
  return window.digitalData.push({
    sha: {
      productocross: product,
      ..._sha
    },
    event,
  })
}

const setPhoneSha = ({ product, phone }) => {
  return setMetadataSha({
    product,
    event: "trackPhoneSha",
    sha: {
      phone
    }
  })
}

const setEmailSha = ({ product, email }) => {
  return setMetadataSha({
    product,
    event: "trackMailSha",
    sha: {
      mail: email
    }
  })
}

export const getNextResetDate = (startDate, finalDate, resetDays) => {
  const start = new Date(startDate);
  const end = new Date(finalDate);
  const now = new Date();

  if (now < start || now > end) return null;

  if (resetDays === 0) return end;

  const msPerReset = resetDays * DAY_TO_MILISECONDS;
  const elapsed = now.getTime() - start.getTime();
  const resetsPassed = Math.floor(elapsed / msPerReset);
  const nextReset = new Date(start.getTime() + (resetsPassed + 1) * msPerReset);

  return nextReset > end ? end : nextReset;
};

export const shouldShowBanner = (time) => {
  if (!time?.start_date || !time?.final_date) return false;

  const start = new Date(time.start_date);
  const end = new Date(time.final_date);
  const now = new Date();

  if (isNaN(start.getTime()) || isNaN(end.getTime())) return false;

  if (start > end) return false;

  return now >= start && now <= end;
};

export const isValidUrl = (url) => {
  if (!url) return false;
  const trimmed = url.trim();
  return /^(https:\/\/[\w.-]+\.[a-z]{2,}(\/\S*)?|mailto:[\w.%+-]+@[\w.-]+\.[a-z]{2,}|tel:\+?\d{6,})$/i.test(
    trimmed,
  );
};

export const isValidImage = (image) => {
  return !!(
    image.image_mobile &&
    image.image_mobile.url &&
    image.image_desktop &&
    image.image_desktop.url
  );
};

/**
 * Función que obtiene el identificador del plan a partir de su nombre.
 * @param {string} planName - Nombre completo del plan (ej: "Plan Viajero Full")
 * @returns {string} Identificador del plan en minúsculas (ej: "full")
 * @example
 * getPlanActionName("Plan Viajero Full") returns "full"
 * getPlanActionName("Plan Viajero Anual*") returns "anual"
 */
const getPlanActionName = (planName) => {
  if (!planName) return "";

  const words = planName.split(" ");
  const lastWord = words[words.length - 1] || "";
  const cleanedWord = lastWord.replace(/\*/g, "");
  return cleanedWord.toLowerCase();
};

export default {
  getTrace,
  widthScreen,
  sendEmailSuccessfulPurchase,
  setActionTag,
  getTagAction2,
  changeFinalizadoValueOnLead,
  calcularEdad,
  isAgeAllowed,
  trackResetPasswordCompleted,
  capitalizeString,
  capitalizeFullName,
  completeLink,
  ellipsis,
  handlerErrors,
  getBody,
  zerofill,
  formattingDate,
  formattingPaymentDate,
  formattingNumber,
  urlSearch,
  getLocalstorage,
  downloadFile,
  addQueryString,
  removeDuplicateByAtributte,
  downloadPdf,
  formattingAlertDate,
  round,
  roundWithComma,
  addCommasAndPoint,
  roundTo,
  addComma,
  eventFire,
  simulateMouseClick,
  toCamelCase,
  capitalize,
  typeObject,
  getAsJson,
  getSession,
  getBodyAmplify,
  getBodySimpleWithTrace,
  isApp,
  extractHostname,
  sendEmailNotification,
  wordsUpperCase,
  formatNumberToDecimal,
  getTagChannel,
  getTagApplication,
  getTagMetadata,
  getTagEvent,
  getTagError,
  getTagLog,
  getTagAction,
  getParameterValue,
  getCampaign,
  getLeadsTrace,
  trackInsuranceWithRefundQuote,
  sendMessageToApp,
  isAppleDevice,
  getDeviceOS,
  getBodySimple,
  setTagDigitalID,
  getTagPayment,
  sendTagError,
  getBodySoat,
  setTrackingErrorPago,
  getDocumentTypeName,
  validateVidaPlus,
  getClientUbigeo,
  getTrackBDU,
  validateBirthday,
  getTotalPassengers,
  sendEmailPurchase,
  enviarCorreo,
  validateViajes,
  validateVidaEndosable,
  getMarkingPassengersValue,
  getMarkingPassengersData,
  getTagVirtual,
  maskEmail,
  convertToSafeString,
  setMetadataSha,
  setPhoneSha,
  setEmailSha,
  getHash256FromString,
  maskString,
  getNextResetDate,
  shouldShowBanner,
  isValidUrl,
  isValidImage,
  getPlanActionName,
};
